import { apiClient } from '@/api/client'

export type ReloadTopic = 'energy_data_topic' | 'midnight_data_topic'
export type ReloadPeriod = 'daily' | 'weekly' | 'midnight'

export interface ReloadResponse {
  message?: string
  background?: boolean
  estimated_time?: string
  controller_id?: string
  controller_name?: string
}

export async function reloadControllerData(
  topic: ReloadTopic,
  period: ReloadPeriod,
  controllerId: string,
): Promise<ReloadResponse> {
  const { data } = await apiClient.get<ReloadResponse>(`/portal/controllers/reload/${topic}/${period}/${controllerId}`)
  return data
}

export interface CompletedReload {
  controller_id: string
  controller_name?: string
  total_rows?: number
}

export async function checkReloadStatus(): Promise<{ reloads: CompletedReload[] }> {
  const { data } = await apiClient.get<{ reloads: CompletedReload[] }>('/portal/controllers/api/reload-status/check')
  return data
}

export async function updatePortfolioList(
  actionType: '1' | '2',
  controllerId: string,
): Promise<{ success?: string; error?: string }> {
  const { data } = await apiClient.get<{ success?: string; error?: string }>(
    `/portal/controllers/add-site-system-to-portifolio-list/${actionType}/${controllerId}`,
  )
  return data
}
